import { render, staticRenderFns } from "./xgpaymentset.vue?vue&type=template&id=4efaec8d&"
import script from "./xgpaymentset.vue?vue&type=script&lang=js&"
export * from "./xgpaymentset.vue?vue&type=script&lang=js&"
import style0 from "./xgpaymentset.vue?vue&type=style&index=0&id=4efaec8d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efaec8d')) {
      api.createRecord('4efaec8d', component.options)
    } else {
      api.reload('4efaec8d', component.options)
    }
    module.hot.accept("./xgpaymentset.vue?vue&type=template&id=4efaec8d&", function () {
      api.rerender('4efaec8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/paymentset/xgpaymentset.vue"
export default component.exports